import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { ModuleSchema } from '@fhnw/schemas/module';
import { LEGACY_MODULE_GROUP_ID, STANDARD_MODULE_GROUP_IDS } from './groups';

const ModuleGroupSchema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.ModuleType),
  addMessage: intl.formatMessage(messages.AddModuleType),
  fieldsets: [
    {
      id: 'default',
      title: '',
      fields: ['title', 'description', 'showGroup', 'modules'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.TitleLabel),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    description: {
      title: intl.formatMessage(messages.Description),
      widgetOptions: {
        frontendOptions: {
          widget: 'textarea',
        },
      },
    },
    showGroup: {
      title: intl.formatMessage(messages.ShowModuleType),
      default: true,
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    modules: {
      title: intl.formatMessage(messages.Modules),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: ModuleSchema({ intl: intl }),
          },
        },
      },
    },
  },
  // Parked entries are only editable on the neutral migration group — new
  // module links are maintained via the page properties (#1717).
  conditions: {
    modules: { '@id': LEGACY_MODULE_GROUP_ID },
  },
  required: [],
});

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'title',
        'moduleGroups',
        'degree',
        'showTeaserImage',
        'showUniversity',
      ],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.TitleLabel),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    moduleGroups: {
      title: intl.formatMessage(messages.Modules),
      description: intl.formatMessage(messages.ModulesHelp),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: ModuleGroupSchema(intl),
            itemTitleField: 'title',
            fixedItemIds: STANDARD_MODULE_GROUP_IDS,
          },
        },
      },
      // No array default: applySchemaDefaults deep-merges defaults per index
      // into stored data and would corrupt reordered groups — the standard
      // groups are seeded into the block data by the view instead.
    },
    degree: {
      title: intl.formatMessage(messages.Degree),
      widgetOptions: {
        frontendOptions: {
          widget: 'text',
        },
      },
    },
    showTeaserImage: {
      title: intl.formatMessage(messages.ShowTeaserImage),
      type: 'boolean',
      default: true,
    },
    showUniversity: {
      title: intl.formatMessage(messages.ShowUniversity),
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export default Schema;
